<template>
    <Structure_Popup class="fixed small">
        <template v-slot:popup-header>
            <div class="title-buttons" style="margin-top: 0">
                <div class="title">
                    {{$t('Label transfer')}}
                </div>
                <div class="buttons">
                    <btn square @click="$emit('close')">
                        <i class="fal fa-times"></i>
                    </btn>
                </div>
            </div>
        </template>
        <template v-slot:popup-content>
            <div class="transfer-content">
                <input-select :items="chapters" v-model="chapterId" :label="$t('Chapters')" :placeholder="$t('Chapters')" :require="true"></input-select>
                <input-select :items="[{text:'Duplicate',value:'duplicate'},{text:'Transfer',value:'transfer'}]" v-model="action" :label="$t('Action')" :placeholder="$t('Action')" :require="true"></input-select>
                <p class="help" v-if="error !== ''">
                    {{$t(error)}}
                </p>
            </div>
        </template>
        <template v-slot:popup-footer>
            <div class="mt-2 text-right">
                <btn icon border @click="valide">
                    <i class="fa fa-check"></i>
                    {{$t(action)}}
                </btn>
            </div>
        </template>
    </Structure_Popup>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import {label} from "@/class/label";
import InputSelect from "@/modules/input/input-select";
import {interactiveImage} from "@/class/interactive-image/interactiveImage";
import Structure_Popup from "@/views/structures/Structure_Popup";

export default {
    name: "InteractiveImage_Label_Transfer",
    components:{Structure_Popup, InputSelect, Btn},
    props:{
        label:{type:Object, default: () => new label()},
        interactiveImage:{type:Object, default: () => new interactiveImage()}
    },
    data(){
        return {
            chapterId:this.interactiveImage.chapterGetCurrent().getId(),
            action:'transfer',
            error:''
        }
    },
    methods:{
        close(){
            this.$emit("close")
        },
        valide(){
            let prevChapterId = this.label._chapterId.get()
            
            if(prevChapterId === parseInt(this.chapterId) && this.action === "transfer"){
                this.error = 'You need to change the chapter';
                return;
            }
            
            //on save le label localement
            let chapter = this.interactiveImage.chapterGetById(this.chapterId)
            let prevChapter = this.interactiveImage.chapterGetById(prevChapterId)
            
            if(this.action === "transfer") {
                chapter.addLabel(this.label.getObjectType(), this.label.toReq())
                chapter.save(true)
                prevChapter.removeLabel(this.label.getObjectType(), this.label)
                prevChapter.save(true)
            }
            
            if(this.action === 'duplicate') {
                let req = this.label.toReq();
                req.pk = - new Date().getTime()
                chapter.addLabel(this.label.getObjectType(), req)
                chapter.save(true)
            }
            
            this.$emit("close")
        }
    },
    computed:{
        chapters(){
            let chapters = []
            this.interactiveImage.chaptersGet().forEach((c,k) => {
                chapters.push({
                    text : this.$t('Chapter')+" "+(c.order + 1)+this.$t(": ")+c.title,
                    value:c.getId()
                })
            })
            
            return chapters
        }
    }
}
</script>